// ====================================================
// src/components/block/liveStreamManagement/enchainements/VoletEnchainement.tsx
//
// Balayage à bord dur (pas d'image qui glisse, contrairement à Poussé) : une
// ligne de démarcation traverse le cadre dans la direction choisie, le
// preview apparaît net derrière elle. Le flux final reste fixe en fond.
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';
import { DirectionConfig, DEFAULT_DIRECTION_CONFIG } from './directionUtils';
import DirectionPicker from './DirectionPicker';

class VoletEnchainementImpl extends Enchainement<DirectionConfig> {
  readonly id = 'volet';
  readonly label = 'Volet';
  readonly icon = 'SplitSquareHorizontal';
  readonly defaultConfig: DirectionConfig = DEFAULT_DIRECTION_CONFIG;

  render(input: EnchainementRenderInput, config: DirectionConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;

    // Flux final fixe en fond, plein cadre.
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);

    // Bande balayée : on tourne le repère pour aligner la direction choisie
    // sur l'axe local -Y (cf. directionOffset — même convention d'angle),
    // on découpe la portion déjà balayée dans ce repère, puis on redessine
    // le preview dans le repère NORMAL (non tourné) à travers ce clip.
    const rad  = (config.angleDeg * Math.PI) / 180;
    const diag = Math.sqrt(width * width + height * height);

    ctx.save();
    ctx.translate(width / 2, height / 2);
    ctx.rotate(rad);
    ctx.beginPath();
    ctx.rect(-diag / 2, diag / 2 - progress * diag, diag, progress * diag);
    ctx.clip();
    ctx.rotate(-rad);
    ctx.translate(-width / 2, -height / 2);
    ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    ctx.restore();
  }

  renderControls({ config, onChange }: EnchainementControlProps<DirectionConfig>): React.ReactNode {
    return (
      <DirectionPicker
        angleDeg={config.angleDeg}
        onChange={angleDeg => onChange({ angleDeg })}
      />
    );
  }
}

export const voletEnchainement = new VoletEnchainementImpl();
